import React from 'react'

export default ({title, children}) =>
  <hgroup>
    <h1>{title}</h1>
    {children}
    <hr />
  </hgroup>



// WEBPACK FOOTER //
// ./app/components/Header.js